import IconButton from '@mui/material/IconButton';
import Tooltip, { type TooltipProps } from '@mui/material/Tooltip';
import { InfoIcon } from '@phosphor-icons/react/Info';

type TooltipIconProps = Omit<TooltipProps, 'children'>;

export const TooltipIcon = ({ ...props }: TooltipIconProps) => (
  <Tooltip {...props}>
    <IconButton size="small">
      <InfoIcon />
    </IconButton>
  </Tooltip>
);
